import React from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  InvoicePositionKindPicker,
  InvoicePositionKindPickerProps,
} from '@work4all/components/lib/components/entity-picker/invoice-position-kind-picker/InvoicePositionKindPicker';

import { ErpPositionInvoiceKind } from '@work4all/models/lib/Enums/ErpPositionInvoiceKind.enum';

import { PickerTargetButton } from '../../containers/mask-overlays/locked-inputs';

interface Props
  extends Omit<
    InvoicePositionKindPickerProps<false>,
    'multiple' | 'value' | 'onChange'
  > {
  error?: string;
  value?: ErpPositionInvoiceKind;
  onChange: (value: ErpPositionInvoiceKind) => void;
  disabled?: boolean;
}

export const InvoicePositionKindPickerField = React.forwardRef<
  HTMLDivElement,
  Props
>((props, ref) => {
  const { error, disabled, ...pickerProps } = props;
  const { value = ErpPositionInvoiceKind.STANDARD, onChange } = pickerProps;

  const { t } = useTranslation();

  return (
    <EntityPickerPopover
      picker={
        <InvoicePositionKindPicker
          {...pickerProps}
          multiple={false}
          onChange={(value) => {
            onChange(value?.id);
          }}
          value={{ id: value, name: t(`INVOICE_POSITION_KINDS.${value}`) }}
        />
      }
    >
      <PickerTargetButton
        ref={ref}
        onClear={() => {
          onChange(null);
        }}
        label={t('COMMON.KIND')}
        error={error}
        value={t(`INVOICE_POSITION_KINDS.${value}`)}
        disabled={disabled}
      />
    </EntityPickerPopover>
  );
});
